import axios from 'axios';
import * as constValues from  './constant';
import { clearSession, getAccessToken, getRefreshToken, saveSessionValue } from './auth';
import {isInactiveAccountResponse, rememberInactiveAccountNotice} from './inactiveAccount';

const instance = axios.create({

  //2
  // baseURL: 'http://54.255.82.8/admin'
  // baseURL: 'http://localhost:8082'
  baseURL:constValues.baseUrl_admin
});

instance.defaults.headers.post['Content-Type'] = 'application/json';

const endInactiveSession = () => {
  clearSession();
  rememberInactiveAccountNotice();
  window.location.assign('/');
};

instance.interceptors.request.use(
  request => {
    if (getAccessToken() !== undefined) {
      request.headers.Authorization = 'Bearer ' + getAccessToken();
    }
    return request;
  },
  error => error
);

instance.interceptors.response.use(
  response => response,
  async (error) => {

    if (error.response !== undefined){
      const status = error.response ? error.response.status : 0;
      const originalRequest = error.config || {};
      const isTokenRequest = originalRequest.url && originalRequest.url.indexOf('/oauth/token') !== -1;
      if (isInactiveAccountResponse(error.response.data)) {
        endInactiveSession();
        return Promise.reject(error);
      }
      if (status === 401 && !originalRequest._retry && !isTokenRequest && getRefreshToken()) {
        originalRequest._retry = true;
        const formdata = new FormData();
        formdata.set("refresh_token",getRefreshToken());
        formdata.set("grant_type","refresh_token");


        let isAccessTokenRefreshed = false;
        await axios.post(constValues.baseUrl_admin+'/oauth/token', formdata,{auth:{username:'ceyentra',password:''}} )
          .then(response => {
            if (response !== undefined){
              saveSessionValue('mer_access_token', response.data.access_token);
              saveSessionValue('mer_refresh_token', response.data.refresh_token);
              isAccessTokenRefreshed = true;
            }
          })
          .catch(err => {
            if (err.response && isInactiveAccountResponse(err.response.data)) {
              endInactiveSession();
              return;
            }
            clearSession();
            window.location.assign('/');
          });
        if (isAccessTokenRefreshed) {
          originalRequest.headers['Authorization'] = 'Bearer ' + getAccessToken();
          return instance.request(originalRequest);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
